import { Autocomplete, FormControl, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSuppliers, getSuppliersReset } from "redux/actions/suppliersAction";
import { LabelWithControl } from "./LabelControl";

export const SupplierSiteIdSearchFeild = ({
  isRequired,
  existingSupplierSiteId,
  existingSupplierSiteDisplayName,
  onValueChange,
  error,
}) => {
  const dispatch = useDispatch();
  const suppliersReducer = useSelector((state) => state.suppliers);
  const [supplierSiteIdInputValue, setSupplierSiteIdInputValue] = useState("");
  const [supplierSiteIdOptions, setSupplierSiteIdOptions] = useState([]);
  const [supplierSiteId, setSupplierSiteId] = useState();
  const [supplierSiteIdApiError, setSupplierSiteIdApiError] = useState("");

  useEffect(()=>{
    if(existingSupplierSiteId) {
      setSupplierSiteId(existingSupplierSiteId);
      setSupplierSiteIdInputValue(existingSupplierSiteDisplayName);
    }
  },[existingSupplierSiteId, existingSupplierSiteDisplayName])

  useEffect(() => {
    if (suppliersReducer.isGetSuppliersLoading) {
      setSupplierSiteIdOptions([]);
      setSupplierSiteIdApiError("");
    } else if (suppliersReducer.isGetSuppliersSuccess) {
      if (suppliersReducer.getSuppliersResponse.SupplierInfo) {
        const mappedResponse =
          suppliersReducer.getSuppliersResponse.SupplierInfo.flatMap((item) => {
            return item.SiteInfo.map((site) => {
              return {
                id: site.ebsSiteId,
                name: item.supplierName,
                supplierId: item.ebsSupplierId,
                supplierName: item.supplierName,
                searchOptionToDisplay: `${item.supplierName} - ${site.ebsSiteId}`,
              };
            });
          });

        setSupplierSiteIdOptions(mappedResponse);
      } else if (suppliersReducer.getSuppliersResponse.SiteInfo) {
        const mappedResponse =
          suppliersReducer.getSuppliersResponse.SiteInfo.map((item) => {
            return {
              id: item.ebsSiteId,
              name: item.siteName,
              supplierId: item.ebsSupplierId,
              supplierName: item.SupplierInfo.supplierName,
              searchOptionToDisplay: `${item.ebsSiteId} - ${item.siteName}`,
            };
          });
        setSupplierSiteIdOptions(mappedResponse);
      } else {
        setSupplierSiteIdOptions([]);
      }
      dispatch(getSuppliersReset());
    } else if (suppliersReducer.isGetSuppliersFail) {
      setSupplierSiteIdOptions([]);
      setSupplierSiteIdApiError(
        suppliersReducer.getSuppliersResponse.response.statusText
      );
      dispatch(getSuppliersReset());
    }
  }, [suppliersReducer, dispatch]);

  useEffect(() => {
    setSupplierSiteIdOptions([]);
    const debounce = setTimeout(() => {
      if (
        supplierSiteIdInputValue.length > 0 &&
        !supplierSiteIdInputValue.includes("-")
      ) {
        const payload = {
          searchCriteria: supplierSiteIdInputValue,
        };
        dispatch(getSuppliers(payload));
      }
    }, 500);

    return () => {
      clearTimeout(debounce);
    };
  }, [supplierSiteIdInputValue, dispatch]);

  return (
    <LabelWithControl
      labelId="suppliersiteId"
      label={
        <>
          Supplier Site ID
          {isRequired ? <span style={{ color: "red" }}>*</span> : null}
        </>
      }
    >
      <FormControl required={true} {...(error && { error: true })}>
        <Autocomplete
          key={existingSupplierSiteId}
          id="suppliersiteId"
          size={"small"}
          disablePortal
          freeSolo
          onInputChange={(event, newInputValue) => {
            setSupplierSiteIdInputValue(newInputValue && newInputValue !== 'undefined' ? newInputValue : "");
            setSupplierSiteIdApiError("");
          }}
          inputValue={supplierSiteIdInputValue}
          onChange={(event, newValue) => {
            setSupplierSiteId(newValue?.id);
            onValueChange(event, newValue);
          }}
          options={supplierSiteIdOptions}
          getOptionLabel={(option) => option.searchOptionToDisplay}
          value={supplierSiteId}
          className="autoCompleteStyle"
          renderInput={(params) => (
            <>
              <TextField
                {...params}
                placeholder="Supplier Site ID"
                fullWidth
                error={!!error || !!supplierSiteIdApiError}
                className="dropDownValue locationDropDownValue"
                helperText={
                  <span>
                    {error && <div>{error}</div>}
                    {supplierSiteIdApiError && (
                      <div>{supplierSiteIdApiError}</div>
                    )}
                  </span>
                }
              />
            </>
          )}
        />
      </FormControl>
    </LabelWithControl>
  );
};
